var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "67", height: "67", viewBox: "0 0 67 67", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "linearGradient",
        { x1: "67.892%", y1: "6.031%", x2: "50%", y2: "100%", id: "linearGradient-loader-big" },
        React.createElement("stop", { stopColor: "#F0F0F0", stopOpacity: "0", offset: "0%" }),
        React.createElement("stop", { stopColor: "#E5E5E5", offset: "100%" })
      )
    ),
    React.createElement("circle", { transform: "rotate(53 378.26 12.562)", cx: "187.5", cy: "300.5", r: "31.5", stroke: "url(#linearGradient-loader-big)", strokeWidth: "3", fill: "none", fillRule: "evenodd" })
  );
});